<script setup lang="ts">
withDefaults(defineProps<{ shape?: 'text' | 'rectangle' | 'circle' }>(), { shape: 'text' });
</script>

<template>
  <span class="skeleton-block" :class="`skeleton-block--${shape}`" aria-hidden="true" />
</template>

<style lang="scss">
.skeleton-block {
  animation: skeleton-block-pulse 1.4s ease-in-out infinite;
  background-color: $color-neutral-low;
  display: block;

  &--text {
    border-radius: $radius-tag-small;
    height: 20px;
  }

  &--rectangle {
    border-radius: $radius-xl;
  }

  &--circle {
    aspect-ratio: 1;
    border-radius: $radius-pill;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
}

@keyframes skeleton-block-pulse {
  50% {
    opacity: 0.5;
  }
}
</style>
